module.exports = __webpack_public_path__ + "img/activities-6.52717616.jpg";